// Generic branding configuration
export const BRANDING_CONFIG = {
  'ASA Guidelines': {
    logoName: 'ASALogo',
    altText: 'ASA Guidelines',
  },
};

export const NATIONAL_RECOMMENDATION_BRAND = 'ASA Guidelines';
